// Module
var code = "<div ng-controller=\"ProjectController as projectController\"> <div ng-if=\"templateUrl\" ng-include=\"templateUrl\"></div> </div> ";
// Exports
module.exports = code;